import React, { createContext, useContext, useState, ReactNode } from 'react';

const PomodoroSettingsContext = createContext(null);

export const PomodoroSettingsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [workDuration, setWorkDuration] = useState(() =>
    loadFromLocalStorage('workDuration', 25 * 60)
  );
  const [breakDuration, setBreakDuration] = useState(() =>
    loadFromLocalStorage('breakDuration', 5 * 60)
  );
  const [timerSound, setTimerSound] = useState(() =>
    loadFromLocalStorage('timerSound', 'チャイム')
  );

  // 値が変わったら保存
  React.useEffect(() => {
    saveToLocalStorage('workDuration', workDuration);
  }, [workDuration]);

  React.useEffect(() => {
    saveToLocalStorage('breakDuration', breakDuration);
  }, [breakDuration]);

  React.useEffect(() => {
    saveToLocalStorage('timerSound', timerSound);
  }, [timerSound]);

  return (
    <PomodoroSettingsContext.Provider
      value={{
        workDuration,
        breakDuration,
        timerSound,
        setWorkDuration,
        setBreakDuration,
        setTimerSound,
      }}
    >
      {children}
    </PomodoroSettingsContext.Provider>
  );
};

export const usePomodoroSettings = () => useContext(PomodoroSettingsContext);

// ヘルパー関数
const loadFromLocalStorage = (key, defaultValue) => {
  try {
    const value = localStorage.getItem(key);
    return value !== null ? JSON.parse(value) : defaultValue;
  } catch {
    return defaultValue;
  }
};

const saveToLocalStorage = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // 何もしない
  }
};
